import { isEdge, isElectron, isMac, kinoParticipants, room, screenShare, Video } from "../../libs/roomnew";

export default class Popup{
    constructor(){
        this.body=null;
        this.screenSharePopup=null;
        this.offsetHeight=0;
        this.visibleVideos=[];
        this.ready=false;
        this.closeModalBtn = `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path></svg>`;

        window.addEventListener('message',event=>{
            let data=event.data;
            // console.log("data received",data)
            if(data && data.eventName){
                if(data.eventName=="screen-share-visible-endpoints-changed"){
                    this.onVisibleEndpointsChanged(data.endpoints);
                }
            }
        })
    }

    isOpen(andReady=true){
        if(this.screenSharePopup && !this.screenSharePopup.closed){
            if(andReady){
                return this.ready;
            }
            return true;
        }
        return false;
    }

    setReady(ready){
        this.ready=ready;
    }
    openPopup(){
        // let height=(kinoParticipants.count() * 113) + 5;
        if(this.isOpen()){
            this.focusWindow();
            return
        }
        // console.log("My screen ",window.screen);
        let screenX=window.screen.width - 260;
        let screenY=95;
        this.screenSharePopup = window.open(``, 'Screen Share',
        'width=200,height=100,popup=1' +
        ',menubar=0' +
        ',toolbar=0' +
        ',status=0' +
        ',screenX='+screenX+
        ',screenY='+screenY+
        ',scrollbars=1' +
        ',resizable=1');
        console.log(this)
        if(!this.screenSharePopup){
            this.showPopupBlockedModal()
            return false
        }
        this.renderContent();
        // this.hiddenBtn=$('<button/>',{
        //     class:'screenshare-hidden-btn',
        //     html:'focus'
        // }).on('click',e=>{
        //     this.focusWindow();
        // });
        // $('screenshare-hidden-btn').remove();
        // $('body').append(this.hiddenBtn)
        return true;
    };
    focusWindow(){
        // console.trace("Focus window",this.screenSharePopup)
        if(this.screenSharePopup && !this.screenSharePopup.closed){
            this.screenSharePopup.blur();
            this.screenSharePopup.focus(); 
        }
    }
    renderContent(){
        let html=`<!DOCTYPE html>
        <html lang="en">
        <head>
            <title>Kino videos pop-up</title>
            <link rel="shortcut icon" href="https://kino.live/images/favicon.ico" type="image/x-icon">
            <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.13.0/css/all.min.css"
            integrity="sha256-h20CPZ0QyXlBuAw7A+KluUYx/3pK+c7lYEpqLTlxjYQ="
            crossorigin="anonymous"
          />
            <link href="${isElectron ? '../..' : ''}/css/share-screen/popup.css?v=${new Date().getTime()}" rel="stylesheet">
            </head>
            <body onBlur="window.focus()">
            <div id="stripVideosContainer" class="scroll-vertical">
            <div id="video-list" class="video-list">
            </div>
            </div>
            </body>
            <script src="${isElectron ? '../..' : ''}/js/share-screen/popup.js?v=${new Date().getTime()}"></script>
        </html>`;
        this.screenSharePopup.document.write(html);
        //set offsets for the window
        if(isElectron){
            if(screenShare.os == "darwin"){
                //set mac desktop offset
                this.offsetHeight=58;
                this.offsetWidth=16;
            }else{
                //set windows desktop offset
                this.offsetHeight=42;
                this.offsetWidth=16;
            }
        }else{
            if(isMac){
                //set chrome mac offset
                this.offsetHeight=87;
                this.offsetWidth=16;
            }else if(isEdge){
                //set edge offset
                this.offsetHeight=73;
                this.offsetWidth=16;
            }else{
                //set chrome windows offset
                this.offsetHeight=70;
                this.offsetWidth=16;
            }
        }
        setTimeout(() => {
            // let shadowOffset=isElectron ? screenShare.os == "darwin" ? -1 : 13 : isMac ? 20 : 0;

            // console.log(`Window ih=${this.screenSharePopup.innerHeight},oh=${this.screenSharePopup.outerHeight}`);
            // this.offsetHeight=this.screenSharePopup.outerHeight-this.screenSharePopup.innerHeight;//-98)+shadowOffset;

            // this.offsetWidth=(this.screenSharePopup.outerWidth-200);
            // if(this.offsetWidth > 16){
            //     this.offsetWidth=16;
            // }
            this.setReady(true)
            this.loadAllVideos();
            // this.screenShareStarted();
        // this.showWatingForScreenshare();
        }, 500);
    };

    showWatingForScreenshare(){
        if(!this.isOpen(false)){return}
        $(`#video-list`,this.screenSharePopup.document).html(`
            <div class="waiting-for-screen-share">
            <div class="waiting-content">
                <i class="fas fa-circle-notch fa-spin"></i>
                <span>Waiting for screenshare</span>
            </div>
        </div>
        `);
        this.screenSharePopup.resizeTo(this.screenSharePopup.outerWidth,200);
    }
    loadAllVideos(){
        if(!this.isOpen()){return}
        $(`#video-list`,this.screenSharePopup.document).html('');
        kinoParticipants.getParticipants().filter(p=>p.inSameSpaceWithMe()).forEach(p => {
            this.addUserVideo(p);
        });
        this.requestEfssCheck();
    }

    screenShareStarted(){
        if(this.isOpen(false)){
            this.focusWindow();
            // this.setReady(true);
            // this.loadAllVideos();
            // window.focus();
            // setTimeout(() => {
            //     // this.hiddenBtn.trigger('click')
            //     this.focusWindow()
            // }, 6000);
        }
    };

    addUserVideo(p){
        if(!p.inSameSpaceWithMe()){return};
        // let inMySpace=p.inMyLobby();
        if($(`#user-${p.id}`,this.screenSharePopup.document).length){
            return
        }
        let name=$("<div/>",{
            class:"user-name",
            html:p.getName() + `${p.local ? ' (me)' : ''}`
        });
        let micMutedIcon=$("<div/>",{
            class:`icon muted-icon ${this.hasMicMuted(p.id) ? '' : 'hidden'}`,
            html:Video.micMutedIcon
        });

        let cameraMutedIcon=$("<div/>",{
            class:`icon camera-muted-icon ${this.hasCameraMuted(p.id) ? '' : 'hidden'}`,
            html:Video.cameraMutedIcon
        });
        let toolboxIcons=$("<div/>",{
            class:"toolbox-icons",
            html:[cameraMutedIcon,micMutedIcon]
        })
        let toolbox=$("<div/>",{
            class:"video-toolbox",
            html:[name,toolboxIcons]
        })
        let video=document.createElement('video');
        video.autoplay=1;
        video.muted=1;
        let videoStream=false;
        if(p.local){
            if(screenShare.presenterEffect){
                console.log("presenter active",screenShare.cameraStream)
                videoStream=screenShare.cameraStream;
            }else{
                videoStream=p.getVideo();
            }
        }else{  
            videoStream=p.getVideo();
        }
        
        if(videoStream){
            video.srcObject=videoStream.stream;
            if(p.local && videoStream.getVideoType()!="desktop"){
                video.classList.add('flipVideoX');
            }
        }
        let noCameraCirce=$('<div/>',{
            class: 'no-cam-layer-background mb-2',
            html: Video.noCameraIcon
        });
        let noCameraLayerThumb=$("<div/>",{
            class:'no-camera-spaces-thumb no-camera-layer d-none',
            html:[noCameraCirce]
        });
        if(Video.videos[p.id]){
            if(!Video.videos[p.id].isVideoPlaying || Video.videos[p.id].isVideoMuted()){
                noCameraLayerThumb.removeClass('d-none')
            }
        }
        let container=$('<div/>',{
            class:`user-video-container ${p.local  ? 'local' : '' }`,
            id:`user-${p.id}`,
            pid:p.id,
            html:[toolbox,video,noCameraLayerThumb]
        })
        // console.log("adding user video",videoStream);
        // console.log("Video list is",$("#video-list",this.screenSharePopup.document));
        $("#video-list",this.screenSharePopup.document).append(container);

        this.resizePopup();
    };

    onUserJoined(user){
        if(!this.isOpen()){return}
        this.addUserVideo(user);
    }
    onUserLeft(pid){
        if(!this.isOpen()){return}
        if($(`#user-${pid}`,this.screenSharePopup.document).length){
            $(`#user-${pid}`,this.screenSharePopup.document).remove();
            this.resizePopup();
        }
    }

    updateVideoStream(pid,stream=false){
        if(!this.isOpen()){return}
        try {
            let user=kinoParticipants.get(pid);
            if(user){
                let videoStream=stream;
                if(!stream){
                    if(user.local){
                        if(screenShare.presenterEffect){
                            console.log("presenter active",screenShare.cameraStream)
                            videoStream=screenShare.cameraStream;
                        }else{
                            videoStream=user.getVideo();
                        }
                    }else{  
                        videoStream=user.getVideo();
                    }
                }
                
                if(videoStream){
                    let videohtml=$(`#user-${pid}`,this.screenSharePopup.document).find("video");
                    // console.log(`Updating video stream for user ${user.getName()} in popup`,videoStream);
                        if(videohtml[0] && videohtml[0].srcObject){
                            let currentTrack=videohtml[0].srcObject.getVideoTracks()[0];
                            let newTrack=videoStream.stream.getVideoTracks()[0];
                            if(currentTrack.id == newTrack.id){
                                return;
                            }
                        }
                        let video=document.createElement('video');
                        video.autoplay=1;
                        video.muted=1;
                        if(user.local && (videoStream.getVideoType()!="desktop")){
                            video.classList.add('flipVideoX');
                        }
                        video.srcObject=videoStream.stream;
                        $(`#user-${pid}`,this.screenSharePopup.document).find("video").remove();
                        $(`#user-${pid}`,this.screenSharePopup.document).append(video);

                }
            }
        } catch (error) {
            console.error('update video track on popup error',error)
        }
    };

    resizePopup(){
        if(!this.isOpen()){return}
        let videosCount=$(`#video-list`,this.screenSharePopup.document).find(".user-video-container").length;
        let maxWidth=330;
        let windowHeight=this.screenSharePopup.outerHeight-this.offsetHeight;
        let windowWidth=this.screenSharePopup.outerWidth > maxWidth ? maxWidth-this.offsetWidth: this.screenSharePopup.outerWidth-this.offsetWidth;
        // let orintation=windowWidth < windowHeight || videosCount == 2 || windowWidth <= 200 ? "portrait" : 'landscape';
        if(windowWidth < 200){windowWidth=200}

        let orintation="portrait";
        let offsetHeight=this.offsetHeight;

        let multiplier=orintation == "portrait" ? Math.ceil(windowWidth / 1.77777) + 1 : Math.ceil(windowHeight * 1.77777);
        let maxSize=window.screen.availHeight-150;
        let neededSize=multiplier*videosCount;
        // console.log(`Current window dimensions w=${windowWidth}x h=${windowHeight} oh=${offsetHeight}ow=${this.offsetWidth},videos=${videosCount},orientation=${orintation},neededSize=${neededSize}`);
        if(orintation == "portrait"){
            if(neededSize<windowHeight){
                this.screenSharePopup.resizeTo(windowWidth+this.offsetWidth,neededSize+offsetHeight);
            }else if(neededSize > windowHeight && neededSize <= maxSize){
                this.screenSharePopup.resizeTo(windowWidth+this.offsetWidth,neededSize+offsetHeight);
            }else{
                this.screenSharePopup.resizeTo(windowWidth+this.offsetWidth,windowHeight+offsetHeight);
            }
        }else{

        }

        
    };

    hasMicMuted(pid){
        if(pid==room.myUserId()){
            return Video.localVideo.hasMicMuted;
        }else if(Video.videos[pid]){
            return Video.videos[pid].hasMicMuted;
        }
        return false;
    }

    hasCameraMuted(pid){
        if(pid==room.myUserId()){
            return Video.localVideo.cameraMutedByMe;
        }else if(Video.videos[pid]){
            return Video.videos[pid].cameraMutedByUser;
        }
    }

    micMuteChanged(pid,muted){
        if(!this.isOpen()){return}
        let micIcon=$(`#user-${pid}`,this.screenSharePopup.document).find(".muted-icon");
        console.log(`Audio mute state changed for participant ${pid} to ${muted}`,micIcon)
        if(muted){
            micIcon.removeClass("hidden");
            return;
        }
        micIcon.addClass("hidden");
    };

    cameraMuteChanged(pid,muted,changeIcon=false){
        if(!this.isOpen()){return}
        let noCameraLayer=$(`#user-${pid}`,this.screenSharePopup.document).find(".no-camera-layer");
        if(changeIcon){
            let cameraIcon=$(`#user-${pid}`,this.screenSharePopup.document).find(".camera-muted-icon");
            if(muted){
                cameraIcon.removeClass('hidden');
            }else{
                cameraIcon.addClass('hidden');
            }
        }
        if(muted){
            noCameraLayer.removeClass("d-none");
            return;
        }
        noCameraLayer.addClass("d-none");
    }


    onVisibleEndpointsChanged(endpoints){
        console.log(`Visible endpoints on screenshare popup changed`,endpoints);
        let remoteEndpoints=endpoints.filter(eid=>eid!=room.myUserId());
        this.visibleVideos=remoteEndpoints;
        Video.setQuality();
        Video.efss.update();
    };

    requestEfssCheck(){
        if(!this.isOpen()){return}
        try {
            this.screenSharePopup.postMessage({
                eventName:'screen-share-efss-check'
            })
        } catch (error) {
            
        }
    }

    speakerChanged(pid){
        if(!this.isOpen()){return}
        console.log("speaker chnaged for screenshare popup",pid);
        let userTile=$(`#user-${pid}`,this.screenSharePopup.document);
        if(userTile){
            // $("#video-list",this.screenSharePopup.document).removeClass('speaker');
            userTile.addClass('speaker');
        }
    }

    removeSpeaker(pid){
        if(!this.isOpen()){return}
        let userTile=$(`#user-${pid}`,this.screenSharePopup.document);
        if(userTile){
            userTile.removeClass('speaker');
        }
    }

    closePopup(){
        if(this.isOpen(false)){
            console.trace("Screenshare popup closed")
            this.screenSharePopup.close();
            this.screenSharePopup=null;
            this.visibleVideos=[];
        }
        this.ready=false;
    }

    setModalShown(){
        localStorage.setItem('allow-popup-modal','skip');
    };
    isModalSkipped(){
        return localStorage.getItem('allow-popup-modal')
    }
    setModalInfoShown(){
        localStorage.setItem('popup-info-modal','skip');
    };
    isModalInfoSkipped(){
        return localStorage.getItem('popup-info-modal')
    }

    showPopupBlockedModal(){
        let rec = this;
        if(rec.adModal){
            rec.adModal.remove()
            rec.adModal=null;
        }

        let checkBox=$('<input/>',{
            id:'do-not-show-popup-checkbox',
            type:'checkbox'
        });
        let checkboxStyled=$("<div/>",{
            class:"round",
            html:[checkBox,`<label for="do-not-show-popup-checkbox"></label>`]
        })
        let dontShowModlaLabel=$('<label/>',{
            html:'Do not show again',
            for:'do-not-show-popup-checkbox'
        });
        let dontShowCheckCont=$('<div/>',{
            class:'do-not-show-check-container styled-checkbox noselect',
            html:[checkboxStyled,dontShowModlaLabel]
        });
        let tipModalFooterCancel = $('<button/>',{
            class: 'btn kino-btn-primary',
            type: 'button',
            // 'data-dismiss': 'modal',
            html: 'Share Screen'
        }).on('click',()=>{
            if(checkBox.is(':checked')){
                rec.setModalShown();
            }
            rec.adModal.modal('hide');
            screenShare.start(false);
        });
        let tipModalFooter = $('<div/>',{
            class: 'modal-footer border-0 pt-0 popup-blocked-footer',
            html: [dontShowCheckCont,tipModalFooterCancel]
        });

        let tipModalBodyHeader = $('<p/>',{
           class: 'text-center mt-2',
           id: 'kino-recorder-text-1',
           html: `<p>When sharing a screen, the video tiles will show in a small window outside of the main Kino window.</p>
           <p>We detected a pop-up blocker that prevents the videos window from showing up.
           Disable the pop-up blocker or allow Kino to view video tiles outside of the main screen.</p>
           `
        });

        let tipModalBodySubHeader = $('<h3/>',{
            class: 'mt-2 text-center',
            id: 'kino-recorder-text-2',
            html: `Video pop-up blocked`
        });

        // let tipModalBodyBottomText = $('<p/>',{
        //     class: 'font-weight-bold text-center',
        //     id: 'kino-recorder-text-3',
        //     html: `<u>${rec.modalBodyBottomText}</u>`
        // });

        let method1=$('<ul/>',{
            class:'guide-list',
            html:[
                `<li>In the address bar, click Pop-up blocked <img src="${isElectron ? '../..' : ''}/images/popup-blocked.png"> icon</li>`,
                `<li>Select <b>Always allow pop-ups and redirects from https://kino.live</b> then click <b>Done</b></li>`
            ]
        });
        let method2=$('<ul/>',{
            class:'guide-list',
            html:[
                '<li>On the top left of the web address, click the lock <i class="fas fa-lock"></i> icon</li>',
                `<li>Click ${isEdge ? '<svg width="20" height="20" viewBox="0 0 20 20" class="c011471 "><path d="M15 6a1 1 0 11-2 0 1 1 0 012 0z"></path><path d="M12.5 2a5.45 5.45 0 00-5.38 6.67c.06.27 0 .5-.14.64l-4.54 4.54A1.5 1.5 0 002 14.91v1.59c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5V16h1a1 1 0 001-1v-1h1a1 1 0 001-1v-.18c.5.13 1 .18 1.5.18 3.08 0 5.5-2.42 5.5-5.5S15.58 2 12.5 2zM8 7.5C8 4.98 9.98 3 12.5 3S17 4.98 17 7.5 15.02 12 12.5 12c-.66 0-1.27-.1-1.78-.35a.5.5 0 00-.72.45v.9H9a1 1 0 00-1 1v1H7a1 1 0 00-1 1v.5a.5.5 0 01-.5.5h-2a.5.5 0 01-.5-.5v-1.59a.5.5 0 01.15-.35l4.54-4.54c.43-.43.52-1.04.4-1.56-.06-.3-.09-.63-.09-.96z"></path></svg> <b>Permissions for this site</b>': '<i class="fas fa-cog"></i> <b>Site settings</b>'}</li>`,
                `<li>Scroll down to <b>Pop-ups and redirects</b> and change to <b>Allow</b></li>`
            ]
        })
        let guideContainer=$("<div/>",{
            class:'guide-container',
            html:[`<div class="method-title pb-0">Method one</div>`,method1,`<div class="method-title">Method two</div>`,method2]
        })

        let showEnablePopupGuideBtn=$('<button/>',{
            class:'btn kino-btn-secondary show-guide-button',
            html:`Allow Kino pop-ups on Chrome&nbsp;<svg fill="none" height="10" width="10" viewBox="0 0 10 6">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.07.248a.75.75 0 111.115 1.004L5.656 5.193a.75.75 0 01-1.115 0L1.068 1.252A.75.75 0 012.182.248L5.1 3.571 8.07.248z" fill="#032836"></path>
                </svg>`
        }).on('click',()=>{
            guideContainer.toggleClass('open');
            showEnablePopupGuideBtn.toggleClass('guide-shown')
        });

        let allowPopupsGuide=$("<div/>",{
            class:'allow-popups-guide',
            html:[showEnablePopupGuideBtn,guideContainer]
        });
        let tipModalBodyWrapper = $('<div/>',{
            class: 'px-1 kino-recorder-modal-body',
            html: [`<img src="${isElectron ? '../..' : ''}/images/screen-share-popup.png" id="popup-blocked-window-img"/>`,tipModalBodySubHeader,tipModalBodyHeader,allowPopupsGuide]
        })

        let tipModalBody = $('<div/>',{
            class: 'modal-body pt-0',
            html: [tipModalBodyWrapper]
        });

        let tipModalTitle = $('<h4/>',{
            class: 'modal-title text-center mb-2',
            id: '',
            html: rec.modalTitle
        });

        // let tipModalSubTitle = $('<span/>',{
        //     class: '',
        //     id: '',
        //     html: rec.modalSubHeader
        // });

        let tipCloseModalBtn = $('<button/>',{
            class: 'close-button-modal-kino',
            type: 'button',
            'data-dismiss': 'modal',
            'aria-label': 'Close',
            html: rec.closeModalBtn
        });

        let tipModalHeader = $('<div/>',{
            class: 'modal-header modal-header-kino',
            html: [tipModalTitle, tipCloseModalBtn]
        });

        let tipModalContent = $('<div/>',{
            class: 'modal-content',
            html: [tipModalHeader, tipModalBody, tipModalFooter]
        });

        let tipModalWrapper = $('<div/>',{
            class: 'modal-dialog',
            role: 'document',
            style: '',
            html: [tipModalContent]
        });

        rec.adModal = $('<div/>',{
            class: 'modal modal-inside-kino fade',
            id: 'start-recording-adBlocker-modal',
            tabindex: '-1',
            role: 'dialog',
            'aria-labelledby': 'start-recording-adBlocker-modal-modalCenterTitle',
            'aria-hidden': 'true',
            'data-keyboard': 'false',
            'data-backdrop': 'static',
            html: [tipModalWrapper]
        });

        rec.adModal.modal();
    };


    showPopupInfoModal(){
        let rec = this;
        if(rec.popypInfoModal){
            rec.popypInfoModal.remove()
            rec.popypInfoModal=null;
        }
        let checkBox=$('<input/>',{
            id:'do-not-show-popup-checkbox',
            type:'checkbox'
        }).on('change',()=>{
            rec.focusWindow();
        });
        let checkboxStyled=$("<div/>",{
            class:"round",
            html:[checkBox,`<label for="do-not-show-popup-checkbox"></label>`]
        })
        let dontShowModlaLabel=$('<label/>',{
            html:'Do not show again',
            for:'do-not-show-popup-checkbox'
        });
        let dontShowCheckCont=$('<div/>',{
            class:'do-not-show-check-container styled-checkbox noselect',
            html:[checkboxStyled,dontShowModlaLabel]
        });
        let tipModalFooterCancel = $('<button/>',{
            class: 'btn kino-btn-primary',
            type: 'button',
            // 'data-dismiss': 'modal',
            html: 'Share Screen'
        }).on('click',()=>{
            if(checkBox.is(':checked')){
                rec.setModalInfoShown();
            }
            rec.popypInfoModal.modal('hide');
            setTimeout(() => {
                rec.popypInfoModal.remove()
                rec.popypInfoModal=null;
            }, 400);
            screenShare.start(false);
            rec.focusWindow();
            // rec.openPopup();
        });
        let tipModalFooter = $('<div/>',{
            class: 'modal-footer border-0 pt-0 popup-blocked-footer',
            html: [dontShowCheckCont,tipModalFooterCancel]
        });

        let tipModalBodyHeader = $('<p/>',{
           class: 'text-center mt-2',
           id: 'kino-recorder-text-1',
           html: `When sharing a screen, the video tiles will show in a small window outside of the main Kino window.
           ${!isElectron ? `<div class="note-text">
            <span class="note">Note</span>
            <span class="note-desc">To keep the pop-up window always on-top use Kino's <a target="_blank" href="https://kino.live/#downloads">desktop app</a></span>
           </div>` : ''}`
        });

        let tipModalBodySubHeader = $('<h3/>',{
            class: 'mt-2 text-center',
            id: 'kino-recorder-text-2',
            html: `Videos pop-up`
        });

        let tipModalBodyWrapper = $('<div/>',{
            class: 'px-1 kino-recorder-modal-body',
            html: [`<img src="${isElectron ? '../..' : ''}/images/screen-share-popup.png" id="popup-blocked-window-img"/>`,tipModalBodySubHeader,tipModalBodyHeader]
        })

        let tipModalBody = $('<div/>',{
            class: 'modal-body pt-0',
            html: [tipModalBodyWrapper]
        });

        let tipModalTitle = $('<h4/>',{
            class: 'modal-title text-center mb-2',
            id: '',
            html: rec.modalTitle
        });

        let tipCloseModalBtn = $('<button/>',{
            class: 'close-button-modal-kino',
            type: 'button',
            'aria-label': 'Close',
            html: rec.closeModalBtn
        }).on('click',()=>{
            rec.popypInfoModal.modal('hide');
            setTimeout(() => {
                rec.popypInfoModal.remove()
                rec.popypInfoModal=null;
            }, 400);
            rec.closePopup();
        });

        let tipModalHeader = $('<div/>',{
            class: 'modal-header modal-header-kino',
            html: [tipModalTitle, tipCloseModalBtn]
        });

        let tipModalContent = $('<div/>',{
            class: 'modal-content',
            html: [tipModalHeader, tipModalBody, tipModalFooter]
        });

        let tipModalWrapper = $('<div/>',{
            class: 'modal-dialog',
            role: 'document',
            style: '',
            html: [tipModalContent]
        });

        rec.popypInfoModal = $('<div/>',{
            class: 'modal modal-inside-kino fade',
            id: 'start-recording-adBlocker-modal',
            tabindex: '-1',
            role: 'dialog',
            'aria-labelledby': 'start-recording-adBlocker-modal-modalCenterTitle',
            'aria-hidden': 'true',
            'data-keyboard': 'false',
            'data-backdrop': 'static',
            html: [tipModalWrapper]
        });

        rec.popypInfoModal.modal();
    };
};